import { fieldsTimeOutValue } from "components/Field/index";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { isUserNameValid, uniqueId } from "utils";

const UserNameField = ({
  userName,
  setUserName,
  userNameError,
  setUserNameError,
  labelText,
  placeHolder,
}) => {
  const id = uniqueId();

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (!initialLoad) {
        if (userName === "") {
          setUserNameError("Cannot be empty");
        } else if (!isUserNameValid(userName)) {
          setUserNameError(
            "There are invalid characters in your User Name. The User Name may only contain ASCII characters, and may not include spaces or any of the following: /:*?\"<>|'"
          );
        } else {
          setUserNameError("");
        }
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [userName]);

  const handleChange = (e) => {
    setUserName(e.target.value);
    if (initialLoad) {
      setInitialLoad(false);
    }
  };

  return (
    <label
      htmlFor={`${id}_form_field-username`}
      className="form__field__username"
    >
      <b>{labelText || "User Name"}</b>
      <input
        type="text"
        id={`${id}_form_field-username`}
        value={userName}
        onChange={handleChange}
        className={userNameError && "input__error"}
        placeholder={placeHolder}
      />
      <span className={`input__error__message ${userNameError && "show"}`}>
        {userNameError}
      </span>
    </label>
  );
};

export default UserNameField;

UserNameField.propTypes = {
  userName: PropTypes.string.isRequired,
  setUserName: PropTypes.func.isRequired,
  userNameError: PropTypes.string.isRequired,
  setUserNameError: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  placeHolder: PropTypes.string,
};
